import gql from 'graphql-tag';

export const GET_FISKALY_TAXPAYER = gql`
  query getFiskalyTaxpayer {
    fiskalyTaxpayer {
      birthdate
      companyName
      firstName
      id
      identificationNumber
      lastName
      legalForm
      personType
      salutation
      taxNumber
      taxOfficeNumber
      vatNumber
    }
  }
`;

export const UPSERT_FISKALY_TAXPAYER = gql`
  mutation UpsertFiskalyTaxpayer($input: UpsertFiskalyTaxpayerInput!) {
    upsertFiskalyTaxpayer(input: $input) {
      fiskalyTaxpayer {
        id
      }
      errors {
        type
      }
    }
  }
`;
